module.exports = __webpack_public_path__ + "img/04@2x.91c11ee7.png";